/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Misc_Downloads_Assetinfo_Applesilicon2Inputs */

const id_misc_downloads_assetinfo_applesilicon2 = /** @type {(inputs: Misc_Downloads_Assetinfo_Applesilicon2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Untuk komputer Mac baru dengan chip Apple (M1, M2, M3, dll.).`)
};

const ms_misc_downloads_assetinfo_applesilicon2 = /** @type {(inputs: Misc_Downloads_Assetinfo_Applesilicon2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Untuk komputer Mac baharu dengan cip Apple (M1, M2, M3, dsb.).`)
};

const da_misc_downloads_assetinfo_applesilicon2 = /** @type {(inputs: Misc_Downloads_Assetinfo_Applesilicon2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Til nyere Mac-computere med Apple-chips (M1, M2, M3, etc.).`)
};

const de_misc_downloads_assetinfo_applesilicon2 = /** @type {(inputs: Misc_Downloads_Assetinfo_Applesilicon2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Für neuere Mac-Computer mit Apple-Chips (M1, M2, M3, etc.).`)
};

const en_us2_misc_downloads_assetinfo_applesilicon2 = /** @type {(inputs: Misc_Downloads_Assetinfo_Applesilicon2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`For newer Mac computers with Apple chips (M1, M2, M3, etc.).`)
};

const es_es2_misc_downloads_assetinfo_applesilicon2 = /** @type {(inputs: Misc_Downloads_Assetinfo_Applesilicon2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Para Mac más nuevos con chips de Apple (M1, M2, M3, etc.).`)
};

const es_mx2_misc_downloads_assetinfo_applesilicon2 = /** @type {(inputs: Misc_Downloads_Assetinfo_Applesilicon2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Para Mac más nuevos con chips de Apple (M1, M2, M3, etc.).`)
};

const fil_misc_downloads_assetinfo_applesilicon2 = /** @type {(inputs: Misc_Downloads_Assetinfo_Applesilicon2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Para sa mga mas bagong Mac computer na may Apple chips (M1, M2, M3, atbp.).`)
};

const fr_misc_downloads_assetinfo_applesilicon2 = /** @type {(inputs: Misc_Downloads_Assetinfo_Applesilicon2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pour les Mac récents avec puces Apple (M1, M2, M3, etc.).`)
};

const it_misc_downloads_assetinfo_applesilicon2 = /** @type {(inputs: Misc_Downloads_Assetinfo_Applesilicon2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Per computer Mac più recenti con chip Apple (M1, M2, M3, ecc.).`)
};

const hu_misc_downloads_assetinfo_applesilicon2 = /** @type {(inputs: Misc_Downloads_Assetinfo_Applesilicon2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Újabb Mac számítógépekhez Apple chipekkel (M1, M2, M3, stb.).`)
};

const nl_misc_downloads_assetinfo_applesilicon2 = /** @type {(inputs: Misc_Downloads_Assetinfo_Applesilicon2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Voor nieuwere Mac-computers met Apple-chips (M1, M2, M3, etc.).`)
};

const no_misc_downloads_assetinfo_applesilicon2 = /** @type {(inputs: Misc_Downloads_Assetinfo_Applesilicon2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`For nyere Mac-datamaskiner med Apple-brikker (M1, M2, M3, etc.).`)
};

const pl_misc_downloads_assetinfo_applesilicon2 = /** @type {(inputs: Misc_Downloads_Assetinfo_Applesilicon2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dla nowszych komputerów Mac z układami Apple (M1, M2, M3 itp.).`)
};

const pt_br2_misc_downloads_assetinfo_applesilicon2 = /** @type {(inputs: Misc_Downloads_Assetinfo_Applesilicon2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Para computadores Mac mais recentes com chips Apple (M1, M2, M3, etc.).`)
};

const pt_misc_downloads_assetinfo_applesilicon2 = /** @type {(inputs: Misc_Downloads_Assetinfo_Applesilicon2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Para Mac mais recentes com chips Apple (M1, M2, M3, etc.).`)
};

const ro_misc_downloads_assetinfo_applesilicon2 = /** @type {(inputs: Misc_Downloads_Assetinfo_Applesilicon2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pentru Mac-uri mai noi cu cipuri Apple (M1, M2, M3, etc.).`)
};

const fi_misc_downloads_assetinfo_applesilicon2 = /** @type {(inputs: Misc_Downloads_Assetinfo_Applesilicon2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uudemmille Mac-tietokoneille, joissa on Apple-siru (M1, M2, M3 jne.).`)
};

const sv_misc_downloads_assetinfo_applesilicon2 = /** @type {(inputs: Misc_Downloads_Assetinfo_Applesilicon2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`För nyare Mac-datorer med Apple-chips (M1, M2, M3, etc.).`)
};

const vi_misc_downloads_assetinfo_applesilicon2 = /** @type {(inputs: Misc_Downloads_Assetinfo_Applesilicon2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dành cho máy Mac mới hơn với chip Apple (M1, M2, M3, v.v.).`)
};

const tr_misc_downloads_assetinfo_applesilicon2 = /** @type {(inputs: Misc_Downloads_Assetinfo_Applesilicon2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Apple çipli (M1, M2, M3, vb.) daha yeni Mac bilgisayarlar için.`)
};

const cs_misc_downloads_assetinfo_applesilicon2 = /** @type {(inputs: Misc_Downloads_Assetinfo_Applesilicon2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pro novější Mac počítače s čipy Apple (M1, M2, M3 atd.).`)
};

const bg_misc_downloads_assetinfo_applesilicon2 = /** @type {(inputs: Misc_Downloads_Assetinfo_Applesilicon2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`За по-нови Mac компютри с чипове на Apple (M1, M2, M3 и др.).`)
};

const ru_misc_downloads_assetinfo_applesilicon2 = /** @type {(inputs: Misc_Downloads_Assetinfo_Applesilicon2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Для новых компьютеров Mac с чипами Apple (M1, M2, M3, M4, M5, M6 и т.д.).`)
};

const uk_misc_downloads_assetinfo_applesilicon2 = /** @type {(inputs: Misc_Downloads_Assetinfo_Applesilicon2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Для новіших комп'ютерів Mac з чипами Apple (M1, M2, M3 тощо).`)
};

const ar_misc_downloads_assetinfo_applesilicon2 = /** @type {(inputs: Misc_Downloads_Assetinfo_Applesilicon2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`لأجهزة Mac الأحدث بشرائح Apple (M1 وM2 وM3 إلخ).`)
};

const hi_misc_downloads_assetinfo_applesilicon2 = /** @type {(inputs: Misc_Downloads_Assetinfo_Applesilicon2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Apple चिप वाले नए Mac के लिए।`)
};

const th_misc_downloads_assetinfo_applesilicon2 = /** @type {(inputs: Misc_Downloads_Assetinfo_Applesilicon2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`สำหรับ Mac รุ่นใหม่ที่มีชิป Apple (M1, M2, M3 ฯลฯ)`)
};

const ja_misc_downloads_assetinfo_applesilicon2 = /** @type {(inputs: Misc_Downloads_Assetinfo_Applesilicon2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Apple チップ (M1, M2, M3 など) 搭載の新しい Mac コンピュータ向け。`)
};

const zh_cn2_misc_downloads_assetinfo_applesilicon2 = /** @type {(inputs: Misc_Downloads_Assetinfo_Applesilicon2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`适用于搭载 Apple 芯片（M1、M2、M3 等）的较新 Mac。`)
};

const zh_hant1_misc_downloads_assetinfo_applesilicon2 = /** @type {(inputs: Misc_Downloads_Assetinfo_Applesilicon2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`適用於搭載 Apple 晶片（M1、M2、M3 等）的較新 Mac。`)
};

const ko_misc_downloads_assetinfo_applesilicon2 = /** @type {(inputs: Misc_Downloads_Assetinfo_Applesilicon2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Apple 칩(M1, M2, M3 등)이 탑재된 최신 Mac 컴퓨터용.`)
};

/**
* | output |
* | --- |
* | "For newer Mac computers with Apple chips (M1, M2, M3, etc.)." |
*
* @param {Misc_Downloads_Assetinfo_Applesilicon2Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const misc_downloads_assetinfo_applesilicon2 = /** @type {((inputs?: Misc_Downloads_Assetinfo_Applesilicon2Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Misc_Downloads_Assetinfo_Applesilicon2Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_misc_downloads_assetinfo_applesilicon2(inputs)
	if (locale === "ms") return ms_misc_downloads_assetinfo_applesilicon2(inputs)
	if (locale === "da") return da_misc_downloads_assetinfo_applesilicon2(inputs)
	if (locale === "de") return de_misc_downloads_assetinfo_applesilicon2(inputs)
	if (locale === "en-US") return en_us2_misc_downloads_assetinfo_applesilicon2(inputs)
	if (locale === "es-ES") return es_es2_misc_downloads_assetinfo_applesilicon2(inputs)
	if (locale === "es-MX") return es_mx2_misc_downloads_assetinfo_applesilicon2(inputs)
	if (locale === "fil") return fil_misc_downloads_assetinfo_applesilicon2(inputs)
	if (locale === "fr") return fr_misc_downloads_assetinfo_applesilicon2(inputs)
	if (locale === "it") return it_misc_downloads_assetinfo_applesilicon2(inputs)
	if (locale === "hu") return hu_misc_downloads_assetinfo_applesilicon2(inputs)
	if (locale === "nl") return nl_misc_downloads_assetinfo_applesilicon2(inputs)
	if (locale === "no") return no_misc_downloads_assetinfo_applesilicon2(inputs)
	if (locale === "pl") return pl_misc_downloads_assetinfo_applesilicon2(inputs)
	if (locale === "pt-BR") return pt_br2_misc_downloads_assetinfo_applesilicon2(inputs)
	if (locale === "pt") return pt_misc_downloads_assetinfo_applesilicon2(inputs)
	if (locale === "ro") return ro_misc_downloads_assetinfo_applesilicon2(inputs)
	if (locale === "fi") return fi_misc_downloads_assetinfo_applesilicon2(inputs)
	if (locale === "sv") return sv_misc_downloads_assetinfo_applesilicon2(inputs)
	if (locale === "vi") return vi_misc_downloads_assetinfo_applesilicon2(inputs)
	if (locale === "tr") return tr_misc_downloads_assetinfo_applesilicon2(inputs)
	if (locale === "cs") return cs_misc_downloads_assetinfo_applesilicon2(inputs)
	if (locale === "bg") return bg_misc_downloads_assetinfo_applesilicon2(inputs)
	if (locale === "ru") return ru_misc_downloads_assetinfo_applesilicon2(inputs)
	if (locale === "uk") return uk_misc_downloads_assetinfo_applesilicon2(inputs)
	if (locale === "ar") return ar_misc_downloads_assetinfo_applesilicon2(inputs)
	if (locale === "hi") return hi_misc_downloads_assetinfo_applesilicon2(inputs)
	if (locale === "th") return th_misc_downloads_assetinfo_applesilicon2(inputs)
	if (locale === "ja") return ja_misc_downloads_assetinfo_applesilicon2(inputs)
	if (locale === "zh-CN") return zh_cn2_misc_downloads_assetinfo_applesilicon2(inputs)
	if (locale === "zh-Hant") return zh_hant1_misc_downloads_assetinfo_applesilicon2(inputs)
	return ko_misc_downloads_assetinfo_applesilicon2(inputs)
});
export { misc_downloads_assetinfo_applesilicon2 as "misc.downloads.assetInfo.appleSilicon" }